
// Test data for Level 3 Iron Training

export const ironTests = [
  {
    id: "iron-precision",
    title: "Les fers - Précision sur le parcours",
    description: "Autour d'un trou, sur le green d'entrainement ou sur le parcours choisissez un trou et matérialisez à l'aide de tees 4 cercles de 2, 4, 6, 10 m. Sur le parcours en terrain naturel ou plat, taper 10 balles depuis aux distances A=110, B=130, C=150 m et compter les points selon le cercle d'arrivée.",
    icon: "🎯"
  },
  {
    id: "iron-green-attack-100",
    title: "Attaque de green 100 m",
    description: "Sur le parcours choisissez un trou et imaginez 4 zones cibles matérialisées par des cercles de 2, 4, 6, 10 m. Vous partagez le green en 2 zones : gauche, droite. L'exercice consiste à taper 10 balles depuis la distance de 100 m, vous notez les points en fonction des cercles d'arrivée et les tendances à gauche, à droite du green.",
    icon: "🎯",
    distance: "100m"
  }
];

// Définition du calcul des points
export const ironScoringGuide = {
  balle2m: 6, // Balle à 2 m du trou: 6 points
  balle4m: 4, // Balle à 4 m: 4 points
  balle6m: 2, // Balle à 6 m: 2 points
  balle10m: 1, // Balle à 10 m: 1 point
  balleHors: 0 // Balle hors cercles: 0 point
};
